import React, {useState} from 'react'; // useEffect

import Grid from '@mui/material/Grid';

import {getUserRoles} from 'ultra/helpers/auth';
import {isAdmin} from 'ultra/helpers/auth';

import {isHiddenField, getFieldStatus} from 'ultra/helpers/content';
// getFormErrors

import Password from './Password';
import Checkbox from './Checkbox';
import Filter from './Filter';
import PartnerPayments from './PartnerPayments';
import UploadImage from './UploadImage';
import LogoUploader from './LogoUploader';
import UploadGallery from './UploadGallery';
import Text from './Text';
import List from './List';
import Rate from './Rate';
import Date from './Date';
// import DateString from './DateString';
import Timestamp from './Timestamp';
import Messenger from './Messenger';
import TelegramUsername from './TelegramUsername';
import Phone from './Phone';
import Subtitle from './Subtitle';
import Email from './Email';
import Instagram from './Instagram';
import NumberField from './Number';
import Partner from './Partner';
import Price from './Price';
import PriceAndPayments from './PriceAndPayments';
import ProductOptions from './ProductOptions';
import ProductAddons from './ProductAddons';
import Tags from './Tags';
// import TinyMCE from './TinyMCE';
import Textarea from './Textarea';
import JSONEditor from './JSONEditor';
import CKEditor from './CKEditor';
// import Select from './Select';
import Link from './Link';
// import Reference from './-Reference';
import Hidden from './Hidden';
import Path from './Path';
import Node from './Node';
import User from './User';
import BooleanField from './Boolean';
import Location from './Location';
import URL from './URL';

import {useToasterStore} from '../../Stores/toster';

import {useGlobalCustomContext} from '../../Helpers/context'
import {getDefaultValues} from '../../Helpers/content'

import {getTelegramUser} from '../../Helpers/telegram';

import './index.scss'

const Controls = {
  // dateString: DateString,
  // reference: Reference,
  subtitle: Subtitle,
  image: UploadImage,
  logo: LogoUploader,
  gallery: UploadGallery,
  timestamp: Timestamp,
  date: Date,
  messenger: Messenger,
  telegramUsername: TelegramUsername,
  phone: Phone,
  password: Password,
  filter: Filter,
  partnerPayments: PartnerPayments,
  partner: Partner,
  text: Text,
  list: List,
  email: Email,
  instagram: Instagram,
  number: NumberField,
  icon: Text,
  price: Price,
  priceAndPayments: PriceAndPayments,
  productOptions: ProductOptions,
  productAddons: ProductAddons,
  tags: Tags,
  textarea: Textarea,
  rate: Rate,
  json: JSONEditor,
  wysiwyg: CKEditor,
  link: Link,
  hidden: Hidden,
  path: Path,
  node: Node,
  section: Node,
  user: User,
  location: Location,
  url: URL,
  checkbox: Checkbox,
  boolean: BooleanField,
}

export default function Form(props) {
  const {content, fields, order} = props // onInit // isEditMode

  const {userState} = useGlobalCustomContext()

  const roles = getUserRoles(userState?.user, getTelegramUser(), content)

  const [showSystem, setShowSystem] = useState(false)

  // USE ORDER
  const controls = []
  const system = []
  
  // useEffect(() => {
  //   if (onInit) {
  //     onInit({
  //       content,
  //       errors: getFormErrors(fields, content, isEditMode)
  //     })
  //   }
  // }, [])

  if (order) {
    // first render ordered
    order.map(fieldId => {
      if (getFieldStatus(fields[fieldId], roles)['edit'] === 'hidden') return;

      if (fields[fieldId]) {
        if (fields[fieldId]?.options?.system) {
          system.push({...fields[fieldId], id: fieldId})
        } else {
          controls.push({...fields[fieldId], id: fieldId})
        }
      }
    })

    // then all other
    Object.keys(fields).map(fieldId => {
      if (getFieldStatus(fields[fieldId], roles)['edit'] === 'hidden') return;

      if (!order.includes(fieldId)) {
        if (fields[fieldId]?.options?.system) {
          system.push({...fields[fieldId], id: fieldId})
        } else {
          controls.push({...fields[fieldId], id: fieldId})
        }
      }
    })
  }
  // disordered render
  else {
    Object.keys(fields).map(fieldId => {
      if (getFieldStatus(fields[fieldId], roles)['edit'] === 'hidden') return;

      if (fields[fieldId]?.options?.system) {
        system.push({...fields[fieldId], id: fieldId})
      } else {
        controls.push({...fields[fieldId], id: fieldId})
      }
    })
  }

  return <>
    {controls && controls.length > 0 && controls.map(field => 
      <RenderControl key={field.id} {...props} field={field} />
    )}
    {isAdmin(userState?.user) && system && system.length > 0 && <>
        <Grid item xs={12}>
          <div className={`systemFields ${showSystem ? 'systemFieldsOpen' : ''}`} onClick={() => setShowSystem(!showSystem)}> {showSystem ? '-' : '+'} <span className='pseudoLink'>Системні параметри</span></div>
        </Grid>

        {showSystem && system.map(field =>
          <RenderControl key={field.id} {...props} field={field} />
        )}
      </>
    }
  </>
}

const RenderControl = React.memo(({field, isEditMode, content, disabled, roles, formActions, onBlur, onChange}) => {
  const {showError} = useToasterStore();
  
  const {userState} = useGlobalCustomContext()

  const isDisabledForNotAllowedUsers = getFieldStatus(field, roles)['edit'] === 'disabled'; // isEditMode
  const controlDisabled = isDisabledForNotAllowedUsers || disabled;

  const onFieldClickHandler = (text) => {
    showError({snackbarMessage: text})
  }

  if (field.type === 'hidden') return <></>

  if (typeof Controls[field.type] === 'undefined') {
    return React.createElement(() => <Grid key={field.id} item xs={field?.layout?.xs || 12} md={field?.layout?.md || 12}>
        <div className='noComponent'>Тип поля {field.type} не має відповідного компоненту</div>
      </Grid>
    )
  }

  if (isHiddenField(field, content)) {
    if (content[field.id]) delete content[field.id];
    return false;
  }

  if (field.visible && !isHiddenField(field, content)) {
    const def = getDefaultValues({[field.id]: content[field.id]}, {fields: {[field.id]: field}}, userState, isEditMode);
    if (!content[field.id]) content[field.id] = def[field.id];
  }

  return <Grid key={field.id} item xs={field?.layout?.xs || 12} md={field?.layout?.md || 12}>
    <div className='controlWrapper'>
      {controlDisabled && field?.options?.disabledFieldHint && <div className='controlWrapperDisabled' onClick={() => onFieldClickHandler(field?.options?.disabledFieldHint)}></div>}
      {React.createElement(Controls[field.type], {
        key: field.id,
        disabled: controlDisabled, // isEditControlDisabledForNotAllowedUsers
        content,
        field,
        isEditMode,
        formActions,
        onChange: (e) => { onChange(e, field) },
        onBlur: (e) => { onBlur(e, field) },
      })}
    </div>
  </Grid>;
});
